import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/preview/zipRenderer/styles.scss';export default {
  "node": "_node_ilfmw_1"
};